import { CommonModule } from '@angular/common';
import { Component, OnDestroy, inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { IonicModule, ModalController } from '@ionic/angular';
import { CreateUnverifiedUserService } from './create-unverified-user.service';
import { Subject, map, startWith, switchMap, takeUntil, tap } from 'rxjs';
import { UserService } from '../../../_core/services/user.service';
import { TranslateModule } from '@ngx-translate/core';

interface UserData {
  first_name: string;
  last_name: string;
}

@Component({
  selector: 'app-create-unverified-user',
  templateUrl: './create-unverified-user.component.html',
  styleUrls: ['./create-unverified-user.component.scss'],
  standalone: true,
  imports: [
    IonicModule,
    CommonModule,
    ReactiveFormsModule,
    TranslateModule
  ]
})

export class CreateUnverifiedUserComponent implements OnDestroy {
  private modalController = inject(ModalController);
  private userService = inject(UserService);

  form = new FormGroup({
    first_name: new FormControl('', { nonNullable: true, validators:[Validators.required] }),
    last_name: new FormControl('', { nonNullable: true, validators:[Validators.required] })
  })

  submitForm$ = new Subject<UserData>()

  private readonly destroy$: Subject<void> = new Subject();

  constructor() {
    this.submitForm$.subscribe(res => {
      //console.log(res)
    })
  }

  async ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  submit() {    
    if (this.form.invalid) {
      return;
    }
    this.userService.create(this.form.getRawValue())
      .pipe(
        takeUntil(this.destroy$),
        map(res => res.data)
      )
      .subscribe(
        user => this.modalController.dismiss(user)
      ) 
  }

  async close() {
    await this.modalController.dismiss();
  }

}
